import RecordBase from './Base';
import { useTranslation } from 'react-i18next';
import dig from 'object-dig';

export default class PinRecord extends RecordBase {
  static defaultAttributes = {
    code: '',
    pan: '',
    status: '',
    batch: '',
    serial: '',
    is_active: true,
    quantity_used: 0,
    activated_at: null,
    desactived_at: null,
    expires_at: null,
    user: null,
    user_id: null,
    product: null,
    product_id: null,
    created_at: '',
    updated_at: '',
  };

  static _attributeNames = null;

  static get attributeNames() {
    const { t } = useTranslation();
    const trAttr = (attr) => t(`pins.attributes.${attr}`);
    if (!this._attributeNames) {
      this._attributeNames = {
        code: trAttr('code'),
        pan: trAttr('pan'),
        status: trAttr('status'),
        batch: trAttr('batch'),
        serial: trAttr('serial'),
        is_active: trAttr('is_active'),
        quantity_used: trAttr('quantity_used'),
        quantity_pending: trAttr('quantity_pending'),
        product_quantity: trAttr('product_quantity'),
        activated_at: trAttr('activated_at'),
        desactived_at: trAttr('desactived_at'),
        expires_at: trAttr('expires_at'),
        user: trAttr('user'),
        user_id: trAttr('user_id'),
        product: trAttr('product'),
        product_id: trAttr('product_id'),
        created_at: trAttr('created_at'),
        updated_at: trAttr('updated_at'),
      };
    }
    return this._attributeNames;
  }

  toParams(attrs = {}) {
    const {
      code,
      pan,
      status,
      batch,
      serial,
      is_active,
      quantity_used,
      expires_at,
      activated_at,
      desactived_at,
      created_at,
      updated_at,
    } = this.toObject();

    return {
      data: {
        attributes: {
          code,
          pan,
          status,
          batch,
          serial,
          is_active,
          quantity_used,
          expires_at,
          activated_at,
          desactived_at,
          user_id: dig(this.get('user'), 'id'),
          product_id: dig(this.get('product'), 'id'),
          created_at,
          updated_at,
          ...attrs,
        },
      },
    };
  }
}
